import { IWebhook } from "../interfaces/common/webhooks";

export const emptyWebhook: IWebhook = {
    id: 0,
    name: "",
    endpoint: "",
    is_active: true,
    secret: "",
}